<script setup lang="ts">
import { ref, onMounted } from 'vue'

const emit = defineEmits<{
  'go-home': []
}>()

const showScreen = ref(false)

onMounted(() => {
  setTimeout(() => {
    showScreen.value = true
  }, 100)
})

const goHome = () => {
  emit('go-home')
}
</script>

<template>
  <div class="screen min-h-screen bg-gradient-to-br from-orange-50 to-orange-100 flex items-center justify-center p-4">
    <transition
      appear
      enter-active-class="transition-all duration-500 ease-out"
      enter-from-class="opacity-0 scale-90"
      enter-to-class="opacity-100 scale-100"
    >
      <div 
        v-if="showScreen"
        class="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center"
      >
        <!-- Icono de jugador desconectado -->
        <div class="mb-6">
          <div class="inline-flex items-center justify-center w-24 h-24 bg-orange-100 rounded-full">
            <svg class="w-12 h-12 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
        </div>

        <!-- Título -->
        <h1 class="text-3xl font-bold text-gray-800 mb-4">
          ¡Jugador Desconectado!
        </h1>

        <!-- Descripción -->
        <p class="text-lg text-gray-600 mb-8">
          Uno de los jugadores se ha desconectado y el juego no puede continuar.
        </p>

        <!-- Botón de acción -->
        <button
          @click="goHome"
          class="w-full bg-orange-600 hover:bg-orange-700 text-white font-bold py-4 px-8 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg"
        >
          🏠 Volver al Inicio
        </button>

        <!-- Información adicional -->
        <div class="mt-6 p-4 bg-orange-50 rounded-lg border border-orange-200">
          <p class="text-sm text-orange-800">
            <strong>Nota:</strong> Puedes crear una nueva sala y volver a empezar con todos los jugadores.
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.screen {
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>